<template>
  <div class="error-page-wrapper d-flex align-items-center justify-content-center">

    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12 col-md-8 col-lg-5">

          <div class="card border-0 shadow-lg animate-card">

            <div class="card-body text-center p-5">
              <div class="mb-4">
                <img alt="error" src="@/assets/img/error.svg" class="img-fluid error-icon">
              </div>

              <h3 class="mb-3 font-weight-bold text-dark">¡Lo sentimos!</h3>

              <p class="text-muted mb-4 text-message">
                El código QR con el cuál intentas ingresar ya no es válido o ha expirado.
                <br>
                Por favor, solicita uno nuevo e intenta nuevamente.
              </p>

              <p class="font-weight-bold text-dark mb-0">Muchas gracias</p>
            </div>

            <div class="card-footer bg-transparent border-0 text-center pb-4">
              <img src="@/assets/img/idata.svg" class="idata-profile opacity-75" alt="idata-profile-pic">
            </div>

          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ErrorMessage',
  props: [],
  data() {
    return {};
  },
  computed: {},
  methods: {},
};
</script>

<style lang='scss' scoped>
.error-page-wrapper {
  background-color: #002639;
  min-height: 100vh; /* Ocupa toda la altura de la pantalla */
  width: 100%;
  padding: 20px;
}

.card {
  border-radius: 1rem; /* Bordes más redondeados */
  overflow: hidden;
}

.error-icon {
  width: 5rem; /* Un poco más grande que antes */
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(1.1) rotate(-5deg);
  }
}

.text-message {
  font-size: 1.05rem;
  line-height: 1.6;
}

.idata-profile {
  max-width: 100px; /* Controlamos el tamaño del logo del footer */
  height: auto;
}

.opacity-75 {
  opacity: 0.75;
}

/* Animación simple de entrada */
.animate-card {
  animation: fadeInUp 0.6s ease-out forwards;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
